let _session: {[index:string]: any}|null = null;

export function startNewSession() {
  _session = {};
  saveSession(_session);
}

export function setSessionItem(key: string, value: any) {
  if(!_session) {
    _session = loadSession();
  }
  _session[key] = value;
  saveSession(_session);
}

export function getSessionItem(key: string): any {
  if(!_session) {
    _session = loadSession();
  }
  return _session[key];
}

export function removeSessionItem(key: string) {
  if(_session) {
    delete _session[key];
    saveSession(_session);
  }
}

function loadSession(): {[index:string]: any} {
  if(!window.localStorage) {
    return {};
  }
  const sessionStr = window.localStorage.getItem('sook.session');
  let session = null;
  if(sessionStr) {
    try {
      session = JSON.parse(sessionStr);
    } catch (err) {
      console.warn("Failed to deserialize session", err);
    }
  }
  return session || {};
}

function saveSession(session: {[index:string]: any}) {
  if(!window.localStorage) {
    return;
  }
  window.localStorage.setItem('sook.session', JSON.stringify(session));
}